import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import logoSource from './breezeway_logo.png';
import logoSourceSmall from './breezeway_logo_135.png';

import './logo.scss';

export const LOGO_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

const logoSources = {
  medium: logoSource,
  small: logoSourceSmall,
};

const Logo = props => (
  <Link to="/" className={`logo logo--${props.size}`}>
    <img src={logoSources[props.size]} className="logo__image" alt="Breezeway" />
  </Link>
);

Logo.propTypes = {
  size: PropTypes.oneOf(Object.values(LOGO_SIZES)),
};

Logo.defaultProps = {
  size: LOGO_SIZES.MEDIUM,
};

export default Logo;
